import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'OpenBuilds.ir',
    description: 'کیت کامل دستگاه CNC رومیزی، پروفیل شیاردار مهندسی، موتور، درایور و کنترلر. ارسال از انبار تهران با ضمانت و خدمات پس از فروش.',
    url: 'https://openbuilds.ir'
}
